import React from 'react';
import { Form } from 'semantic-ui-react';

const TenoviPulseOx = ({
  tenoviDeviceTypes,
  setTenoviDeviceTypes,
}) => {
  return (
    <>
      <Form.Group inline>
        <label style={{ width: '150px' }}>Pulse Oximeter</label>
        <Form.Radio
          label="Request"
          value="request"
          checked={
            tenoviDeviceTypes.TENOVI_PULSE_OX.state === 'request'
          }
          onChange={(e, { value }) =>
            setTenoviDeviceTypes({
              ...tenoviDeviceTypes,
              TENOVI_PULSE_OX: {
                ...tenoviDeviceTypes.TENOVI_PULSE_OX,
                state: value,
              },
            })
          }
        />
        <Form.Radio
          label="Connect"
          value="connect"
          checked={
            tenoviDeviceTypes.TENOVI_PULSE_OX.state === 'connect'
          }
          onChange={(e, { value }) =>
            setTenoviDeviceTypes({
              ...tenoviDeviceTypes,
              TENOVI_PULSE_OX: {
                ...tenoviDeviceTypes.TENOVI_PULSE_OX,
                state: value,
              },
            })
          }
        />
        <Form.Radio
          label="Not needed"
          value="notNeeded"
          checked={
            tenoviDeviceTypes.TENOVI_PULSE_OX.state === 'notNeeded'
          }
          onChange={(e, { value }) =>
            setTenoviDeviceTypes({
              ...tenoviDeviceTypes,
              TENOVI_PULSE_OX: {
                ...tenoviDeviceTypes.TENOVI_PULSE_OX,
                state: value,
              },
            })
          }
        />
      </Form.Group>
    </>
  );
};

export default TenoviPulseOx;
